import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

export default function UnsavedChangesDialog({ open, onCancel, onLeave, onSaveAndLeave, saving }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="bg-zinc-900 border-zinc-800" data-testid="unsaved-changes-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">You have unsaved changes</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400">
            If you leave now, changes to this programme will be lost.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} className="border-zinc-700 text-zinc-300 bg-transparent" data-testid="unsaved-stay-btn">Stay on page</AlertDialogCancel>
          <AlertDialogAction onClick={onLeave} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="unsaved-leave-btn">Leave without saving</AlertDialogAction>
          <AlertDialogAction onClick={onSaveAndLeave} disabled={saving} className="bg-teal-600 hover:bg-teal-700 text-white" data-testid="unsaved-save-leave-btn">Save &amp; leave</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
